/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Upload_Valid_DeckInputs */



/**
* | output |
* | --- |
* | "Upload a valid deck to check in" |
*
* @param {Tournament_Upload_Valid_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_upload_valid_deck = /** @type {((inputs?: Tournament_Upload_Valid_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Upload_Valid_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléchargez un deck valide pour pointer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargue un deck válido para hacer check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Envie um deck válido para fazer check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica un deck valido per fare check in")
	return /** @type {LocalizedString} */ ("Upload a valid deck to check in")
});